import React from 'react';

export default class Header extends React.Component {
    render() {
        return (
            <div>
                <div className="product-header__column">
                    <h1 className="product__title">{this.props.text}</h1>
                    <div className="product-header__material">Solid 14k Gold</div>
                </div>
            </div>
        );
    }
}
